import React from 'react';
import { useTranslation } from 'react-i18next';

import CustomRadioButton from '../../../shared-components/custom-radio-button/CustomRadioButton';

interface RevenueManagementProperties {
  currentPage: string;
  setCurrentPage: React.Dispatch<React.SetStateAction<string>>;
}

/**
 * Revenue management toggle component
 * @param {any} properties - The properties
 * @returns {any} The result
 */
function RevenueManagementToggle(properties: RevenueManagementProperties) {
  const { t } = useTranslation('revenue');
  const { currentPage, setCurrentPage } = properties;
  /**
   * handle change radio button function
   * @param {any} name - The name
   * @param {any} value - The value
   */
  const handleAvailabilityChange = (name: string, value: string) => {
    setCurrentPage(value);
  };
  return (
    <div className="revenue-management-toggle-wrap">
      <CustomRadioButton
        name=""
        value="account"
        label={t('account')}
        selected={currentPage === 'account'}
        onChangeFunc={handleAvailabilityChange}
      />
      <CustomRadioButton
        name=""
        value="station"
        label={t('station')}
        selected={currentPage === 'station'}
        onChangeFunc={handleAvailabilityChange}
      />
    </div>
  );
}

export default RevenueManagementToggle;
